export function minutesToSessionParts(totalMinutes = 0) {
  const total = Number(totalMinutes) || 0;
  return {
    sessionDays: Math.floor(total / 1440),
    sessionHours: Math.floor((total % 1440) / 60),
    sessionMinutes: total % 60,
  };
}

export function sessionPartsToMinutes({ sessionDays = 0, sessionHours = 0, sessionMinutes = 0 } = {}) {
  return (
    Number(sessionDays) * 24 * 60 +
    Number(sessionHours) * 60 +
    Number(sessionMinutes)
  );
}

export function profileToFormValues(profile = {}) {
  const sessionParts = minutesToSessionParts(profile.session_timeout);
  return {
    organisation: profile.organisation || null,
    name: profile.name || '',
    is_standard: Boolean(profile.is_standard),
    ...sessionParts,
  };
}

export function normalizeProfile(profile = {}) {
  if (!profile || typeof profile !== 'object') {
    return null;
  }

  const organisationId =
    profile.organisation?.organisation_id ??
    profile.organisation?.id ??
    profile.organisation;

  return {
    id: profile.id,
    name: profile.name || '',
    is_standard: Boolean(profile.is_standard),
    session_timeout: Number(profile.session_timeout) || 0,
    organisation: organisationId
      ? {
          organisation_id: organisationId,
          name: profile.organisation?.name || profile.organisation_name || '',
        }
      : null,
    permissions: profile.permissions || { features: {}, objects: {} },
    raw: profile,
  };
}

export function normalizeProfileList(data = {}) {
  const list = Array.isArray(data?.list) ? data.list : Array.isArray(data) ? data : [];
  return {
    count: Number(data?.count) || list.length,
    list: list.map((item) => normalizeProfile(item)).filter(Boolean),
  };
}

export function buildCreateProfilePayload(form, { showIsStandard = false } = {}) {
  const payload = {
    name: form.name?.trim(),
    session_timeout: sessionPartsToMinutes(form),
    organisation: form.organisation?.organisation_id ?? form.organisation?.id,
  };
  if (showIsStandard) {
    payload.is_standard = Boolean(form.is_standard);
  }
  return payload;
}

export function buildUpdateProfilePayload(form, profileId, { showIsStandard = false } = {}) {
  const payload = {
    id: profileId,
    name: form.name?.trim(),
    session_timeout: sessionPartsToMinutes(form),
    organisation: form.organisation?.organisation_id ?? form.organisation?.id,
  };
  if (showIsStandard) {
    payload.is_standard = Boolean(form.is_standard);
  }
  return payload;
}

export function filterProfilesByTab(profiles = [], tab = 'all') {
  if (tab === 'standard') {
    return profiles.filter((profile) => profile.is_standard);
  }
  if (tab === 'custom') {
    return profiles.filter((profile) => !profile.is_standard);
  }
  return profiles;
}

export function getProfileTabCounts(profiles = []) {
  return {
    all: profiles.length,
    standard: profiles.filter((profile) => profile.is_standard).length,
    custom: profiles.filter((profile) => !profile.is_standard).length,
  };
}
